import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FormBuilder, UntypedFormGroup } from '@angular/forms';
import { AuthConfigService, RoutingService } from '@spartacus/core';
import { ForgotPasswordComponent } from '@spartacus/user/profile/components';
import { UigForgotPasswordComponentService } from './uig-forgot-password-component.service';

@Component({
    selector: 'app-uig-forgot-password',
    templateUrl: './uig-forgot-password.component.html',
    styleUrls: ['./uig-forgot-password.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class UigForgotPasswordComponent extends ForgotPasswordComponent {

  constructor(
    private forgotPasswordComponentService: UigForgotPasswordComponentService,
  ) {
    super(forgotPasswordComponentService);
  }

  form: UntypedFormGroup = this.forgotPasswordComponentService.form;
  isUpdating$ = this.forgotPasswordComponentService.isUpdating$;

  onSubmit(): void {
    this.forgotPasswordComponentService.requestEmail();
  }
}
